/**
 * Mapping von DB flower_color-Werten auf Anzeige-Properties.
 * Verwendet in: PlantCircle, PlantPropertiesTab, PlantDetailDialog
 */
export const FLOWER_COLOR_MAP = {
  white:  { name: 'Weiß',    hex: '#FFFFFF', border: '#D1D5DB' },
  yellow: { name: 'Gelb',    hex: '#FDE047' },
  orange: { name: 'Orange',  hex: '#FB923C' },
  red:    { name: 'Rot',     hex: '#F87171' },
  pink:   { name: 'Rosa',    hex: '#F9A8D4' },
  purple: { name: 'Purpur',  hex: '#C084FC' },
  violet: { name: 'Violett', hex: '#A78BFA' },
  blue:   { name: 'Blau',    hex: '#60A5FA' },
  green:  { name: 'Grün',    hex: '#86EFAC' },
};

/**
 * Konvertiert einen Hex-Wert in eine RGBA-Farbe mit gegebener Opacity.
 * @param {string} hex - Hex-Farbwert (z.B. '#FDE047')
 * @param {number} opacity - Opacity (0-1)
 * @returns {string} RGBA-String
 */
export function hexToRgba(hex, opacity) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
